export default {
  saving: 'Сохраняется...',
  savedSuccessfully: 'Успешно сохранено',
  errors: {
    requiredField: 'Поле обязательно для заполнения',
    positiveNumber: 'Укажите положительное число',
    positiveIntegerNumber: 'Укажите положительное целое число',
    invalidEmail: 'Неверный формат email',
    invalidUrl: 'Некорректный URL. Пример: https://example.com/path/',
    invalidErid: 'Внесите erid в формате 2RanymKJUZn',
    somethingWentWrong:
      'Произошла непредвиденная ошибка. Пожалуйста, обратитесь в службу технической поддержки.',
  },
}
